{
  "common": {
    "errorOccurred": "An unexpected error occurred.",
    "retry": "Retry",
    "retrying": "Retrying",
    "cancel": "Cancel",
    "comingSoon": "Coming soon",
    "actions": "Actions"
  },
  "httpErrors": {
    "0": "No connection to server",
    "400": "Bad request",
    "401": "Unauthorized",
    "403": "Forbidden",
    "404": "Not found",
    "500": "Server error",
    "default": "Unexpected error occurred"
  },
  "snackbar": {
    "close": "Close"
  },
  "error": {
    "title": "Error",
    "message": "An error occurred",
    "retry": "Retry"
  },
  "loading": {
    "message": "Loading works!"
  },
  "unauthorized": {
    "title": "Access denied",
    "message": "You do not have permission to access this section."
  },
  "invoiceLineItems": {
    "columns": {
      "itemName": "Item Name",
      "amount": "Amount"
    },
    "placeholders": {
      "itemName": "Enter item name",
      "amount": "0"
    },
    "addLineItem": "Add Line Item",
    "deleteRow": "Delete line item",
    "labelField": {
      "label": "Label",
      "placeholder": "FEES"
    }
  },
  "filters": {
    "filter": "Filter",
    "vendor": "Vendor",
    "client": "Client",
    "search": "Search",
    "export": "Export",
    "orderType": "Order Type",
    "orderStatus": "Order Status",
    "slaStatus": "Client SLA Status",
    "clearAll": "Clear all"
  }
}
